export const translations = {
  fr: {
    nav: {
      solution: "Solution",
      who: "Pour qui ?",
      features: "Fonctionnalités",
      resources: "Ressources",
      pricing: "Tarifs",
      login: "Se connecter",
      demo: "Demander une démo",
      tagline: "Operational reporting & BI tracker",
      menu: "Menu",
    },
    hero: {
      eyebrow: "Pilotez le terrain. Simplement. Efficacement.",
      titleLines: ["La solution tout-en-un", "pour des points de vente", "plus performants"],
      subtitle:
        "Orbit accompagne les équipes terrain au quotidien pour simplifier l'exploitation, améliorer la performance et renforcer la communication entre le siège et les points de vente.",
      ctaDemo: "Demander une démo",
      ctaVideo: "Découvrir en vidéo",
      badges: ["Simple à déployer", "Adopté par les équipes", "Des résultats concrets"],
      annotation: "Des équipes engagées font la différence !",
      videoTitle: "Découvrir Orbit en vidéo",
      loginToast: "L'espace client est réservé aux enseignes équipées d'Orbit.",
    },
    marquee: {
      label: "Ils pilotent leurs réseaux avec Orbit",
      brands: ["Big Mamma", "Sushi Shop", "Bagelstein", "Boulangerie Louise", "Naturalia", "Alain Afflelou", "Fnac Darty", "Decathlon"],
    },
    chapters: {
      solution: "La solution",
      who: "Pour qui ?",
      results: "Résultats",
      proof: "Ils en parlent",
      resources: "Ressources",
    },
    pillars: {
      title: "Quatre piliers pour piloter vos réseaux",
      subtitle: "Une plateforme unique, pensée pour le siège comme pour le terrain.",
      items: [
        { title: "Centralisez vos opérations", text: "Une seule plateforme pour toutes vos missions terrain." },
        { title: "Pilotez la performance", text: "Des indicateurs clairs et utiles à chaque niveau." },
        { title: "Engagez vos équipes", text: "Des outils simples, pensés pour le terrain et l'humain." },
        { title: "Déployez vos projets", text: "Du siège au point de vente, avec un suivi en temps réel." },
      ],
    },
    sectors: {
      title: "Une solution conçue pour tous les réseaux",
      subtitle: "Orbit s'adapte à votre secteur et à vos enjeux terrain.",
      more: "En savoir plus",
      items: [
        {
          title: "Restauration",
          text: "Pilotez vos restaurants avec des outils adaptés à vos équipes et à vos opérations.",
        },
        {
          title: "Retail alimentaire",
          text: "Simplifiez la gestion de vos magasins et améliorez votre performance au quotidien.",
        },
        {
          title: "Retail spécialisé",
          text: "Une solution flexible pour tous les concepts de commerce spécialisé.",
        },
      ],
    },
    stats: {
      title: "Des résultats qui parlent d'eux-mêmes",
      subtitle: "La preuve par le terrain, jour après jour.",
      items: [
        { value: 30, prefix: "+", suffix: "%", label: "de productivité terrain en moyenne" },
        { value: 95, prefix: "", suffix: "%", label: "des utilisateurs satisfaits" },
        { value: 500, prefix: "+", suffix: "", label: "points de vente accompagnés" },
        { value: 50, prefix: "+", suffix: "", label: "enseignes nous font confiance" },
      ],
    },
    testimonial: {
      quote:
        "Orbit nous fait gagner un temps précieux au quotidien. Tout est au même endroit, simple et efficace. Mes équipes l'ont tout de suite adopté !",
      name: "Thomas D.",
      role: "Responsable de magasin",
      ctaTitle: "Prêt à faire la différence sur le terrain ?",
      ctaText: "Rejoignez les enseignes qui pilotent leurs points de vente avec Orbit.",
      ctaButton: "Demander une démo",
    },
    faq: {
      title: "Questions fréquentes",
      subtitle: "Tout ce qu'il faut savoir avant de vous lancer.",
      items: [
        {
          q: "Combien de temps prend le déploiement d'Orbit ?",
          a: "Un déploiement type prend de 4 à 8 semaines selon la taille de votre réseau : cadrage, configuration, formation des équipes et accompagnement au lancement sont inclus.",
        },
        {
          q: "Orbit s'intègre-t-il à nos outils existants ?",
          a: "Oui. Orbit se connecte à vos outils de caisse, ERP et RH grâce à nos connecteurs natifs et à notre API ouverte.",
        },
        {
          q: "Les équipes terrain arrivent-elles à prendre l'outil en main ?",
          a: "L'application est pensée mobile-first : la prise en main prend moins d'une heure, sans formation lourde. 95% de nos utilisateurs se déclarent satisfaits.",
        },
        {
          q: "Comment fonctionne la tarification ?",
          a: "Un socle mensuel par enseigne, un coût par magasin actif et des frais de déploiement. Le prix par magasin décroît avec la taille de votre réseau.",
        },
        {
          q: "Nos données sont-elles en sécurité ?",
          a: "Vos données sont hébergées en Europe, chiffrées, avec une gestion fine des droits par rôle et par point de vente.",
        },
      ],
    },
    featuresPage: {
      eyebrow: "Fonctionnalités",
      title: "Tout le pilotage terrain, dans une seule plateforme",
      subtitle: "Explorez les modules qui structurent le quotidien de vos équipes, du siège au point de vente.",
      tabs: [
        {
          id: "network",
          label: "Vue réseau",
          title: "Votre réseau en un coup d'œil",
          text: "Cartographiez la performance de chaque point de vente en temps réel : chiffre d'affaires, conformité, rituels du jour et alertes prioritaires.",
          points: ["Statuts par magasin en temps réel", "Alertes et incidents centralisés", "Comparaisons inter-sites instantanées"],
        },
        {
          id: "rituals",
          label: "Rituels & check-lists",
          title: "Des rituels simples, suivis à la minute",
          text: "Ouvertures, fermetures, contrôles HACCP : chaque rituel est guidé, horodaté et remonté au siège automatiquement.",
          points: ["Check-lists mobiles avec photos", "Relances automatiques en cas de retard", "Historique complet par point de vente"],
        },
        {
          id: "audits",
          label: "Audits terrain",
          title: "Des audits qui font progresser",
          text: "Grilles d'audit personnalisables, photos annotées et plans d'action assignés directement aux équipes concernées.",
          points: ["Grilles sur mesure par concept", "Score de conformité par visite", "Plans d'action suivis jusqu'à clôture"],
        },
        {
          id: "analytics",
          label: "Analyse comparative",
          title: "Des décisions guidées par la donnée",
          text: "Comparez vos magasins sur les indicateurs qui comptent et identifiez vos leviers de progression, magasin par magasin.",
          points: ["KPI consolidés siège et terrain", "Benchmarks entre points de vente", "Exports et rapports automatisés"],
        },
      ],
      ctaTitle: "Envie de voir Orbit en action ?",
      ctaText: "Une démo de 30 minutes, adaptée à votre secteur et à vos enjeux.",
      ctaButton: "Demander une démo",
    },
    pricing: {
      eyebrow: "Tarifs",
      title: "Des tarifs clairs, adaptés à votre réseau",
      subtitle: "Un socle par enseigne, un coût par magasin actif. Et c'est tout.",
      perMonth: "/mois",
      recommended: "Recommandé",
      modules: "Modules inclus",
      deployment: "Frais de déploiement",
      from: "à partir de",
      perStore: "Prix par magasin actif",
      ranges: ["1 à 50 magasins", "51 à 100 magasins", "101 à 150 magasins", "Au-delà"],
      onQuote: "Sur devis",
      cta: "Demander une démo",
      note: "Chaque abonnement comprend un socle mensuel par enseigne, un coût par magasin actif et des frais de déploiement.",
      plans: [
        {
          name: "Orbit Starter",
          price: "290€",
          modules: ["Intranet", "Centre des opérations", "KPI"],
          deploy: "2 000€",
          storePrices: ["18€", "14€", "10€"],
        },
        {
          name: "Orbit Performance",
          price: "590€",
          modules: ["Tout Starter", "Module Support", "Module Métier"],
          deploy: "4 000€",
          storePrices: ["28€", "22€", "17€"],
        },
        {
          name: "Orbit Sur mesure",
          price: "990€",
          modules: ["Tous les modules", "Développements spécifiques", "Intégrations dédiées"],
          deploy: "8 000€",
          storePrices: ["38€", "30€", "23€"],
        },
      ],
    },
    demo: {
      eyebrow: "Contact",
      title: "Demandez votre démo personnalisée",
      subtitle: "30 minutes avec un expert Orbit pour voir la plateforme en action sur vos cas d'usage.",
      points: ["Réponse sous 24h ouvrées", "Démo adaptée à votre secteur", "Sans engagement"],
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email professionnel",
        phone: "Téléphone",
        company: "Nom de l'enseigne",
        stores: "Nombre de points de vente",
        storesPlaceholder: "Sélectionnez",
        storeOptions: ["1 à 10", "11 à 50", "51 à 100", "101 à 150", "Plus de 150"],
        message: "Message",
        messagePlaceholder: "Parlez-nous de votre réseau et de vos enjeux…",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours…",
      },
      success: "Demande envoyée ! Un expert Orbit vous recontacte sous 24h.",
      error: "Une erreur est survenue. Réessayez dans un instant.",
    },
    footer: {
      baseline: "La solution tout-en-un pour des points de vente plus performants.",
      product: "Produit",
      company: "Entreprise",
      legal: "Légal",
      contact: "Contact",
      legalNotice: "Mentions légales",
      terms: "CGU",
      privacy: "Politique de confidentialité",
      status: "Tous les systèmes opérationnels",
      copyright: "© 2026 Orbit. Tous droits réservés.",
    },
    legal: {
      notice: {
        title: "Mentions légales",
        body: [
          "Éditeur du site : Orbit SAS — 12 rue de la Verrerie, 75004 Paris, France.",
          "Directeur de la publication : La direction Orbit.",
          "Hébergement : infrastructure cloud européenne, données hébergées en Union européenne.",
          "Contact : via le formulaire de demande de démo disponible sur ce site.",
        ],
      },
      terms: {
        title: "Conditions Générales d'Utilisation",
        body: [
          "L'accès à la plateforme Orbit est réservé aux enseignes clientes disposant d'un abonnement en cours de validité.",
          "Chaque utilisateur dispose d'identifiants personnels dont il assure la confidentialité.",
          "Les données saisies dans la plateforme restent la propriété exclusive de l'enseigne cliente.",
          "Orbit s'engage à un taux de disponibilité de 99,9% et à un support réactif en jours ouvrés.",
        ],
      },
      privacy: {
        title: "Politique de confidentialité",
        body: [
          "Les données collectées via le formulaire de démo (identité, coordonnées professionnelles, enseigne) servent uniquement à traiter votre demande.",
          "Aucune donnée n'est cédée à des tiers à des fins commerciales.",
          "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.",
          "Pour exercer ces droits, contactez-nous via le formulaire de démo.",
        ],
      },
    },
    mockup: {
      hello: "Bonjour Camille !",
      sub: "Un magasin bien préparé, des clients satisfaits !",
      weather: "Pluie légère",
      store: "Leclerc Versailles",
      search: "Rechercher un document, une tâche…",
      kpis: [
        { label: "CA du jour", value: "12 450 €", trend: "+8% vs hier", up: true },
        { label: "Passages", value: "1 203", trend: "+12% vs lundi", up: true },
        { label: "Panier moyen", value: "10,35 €", trend: "-2% vs semaine", up: false },
        { label: "Objectif du jour", value: "86%", trend: "72 500 € / 85 000 €", up: true },
      ],
      dayTitle: "Ma journée",
      dayLink: "Voir toute ma journée",
      daySub: "2 actions à réaliser · 1 en retard",
      tasks: [
        { time: "07:00", label: "Ouverture magasin", status: "done" },
        { time: "08:30", label: "Contrôle sécurité", status: "done" },
        { time: "09:30", label: "Réception fournisseur", status: "late" },
        { time: "11:00", label: "Mise en place opération", status: "todo" },
      ],
      late: "En retard",
      newsTitle: "Actualités réseau",
      newsLink: "Voir tout",
      newsTag: "C'est la rentrée !",
      newsText: "Découvrez le nouveau dispositif en magasin.",
      newsCta: "Voir les éléments",
      sidebar: ["Accueil", "Ma journée", "Mes rituels", "Inventaire", "Demandes & incidents", "Documents", "Mon site", "Modules métier"],
    },
  },
  en: {
    nav: {
      solution: "Solution",
      who: "Who is it for?",
      features: "Features",
      resources: "Resources",
      pricing: "Pricing",
      login: "Log in",
      demo: "Book a demo",
      tagline: "Operational reporting & BI tracker",
      menu: "Menu",
    },
    hero: {
      eyebrow: "Run your field operations. Simply. Efficiently.",
      titleLines: ["The all-in-one solution", "for higher-performing", "points of sale"],
      subtitle:
        "Orbit supports field teams every day to simplify operations, improve performance and strengthen communication between headquarters and stores.",
      ctaDemo: "Book a demo",
      ctaVideo: "Watch the video",
      badges: ["Easy to roll out", "Adopted by teams", "Concrete results"],
      annotation: "Engaged teams make the difference!",
      videoTitle: "Discover Orbit on video",
      loginToast: "The client area is reserved for brands using Orbit.",
    },
    marquee: {
      label: "They run their networks with Orbit",
      brands: ["Big Mamma", "Sushi Shop", "Bagelstein", "Boulangerie Louise", "Naturalia", "Alain Afflelou", "Fnac Darty", "Decathlon"],
    },
    chapters: {
      solution: "The solution",
      who: "Who is it for?",
      results: "Results",
      proof: "Testimonials",
      resources: "Resources",
    },
    pillars: {
      title: "Four pillars to run your networks",
      subtitle: "A single platform, designed for both headquarters and the field.",
      items: [
        { title: "Centralise your operations", text: "One platform for all your field missions." },
        { title: "Drive performance", text: "Clear, actionable metrics at every level." },
        { title: "Engage your teams", text: "Simple tools, designed for the field and for people." },
        { title: "Roll out your projects", text: "From HQ to store, with real-time tracking." },
      ],
    },
    sectors: {
      title: "A solution designed for every network",
      subtitle: "Orbit adapts to your sector and your field challenges.",
      more: "Learn more",
      items: [
        { title: "Restaurants", text: "Run your restaurants with tools adapted to your teams and operations." },
        { title: "Food retail", text: "Simplify store management and improve day-to-day performance." },
        { title: "Specialty retail", text: "A flexible solution for every specialty retail concept." },
      ],
    },
    stats: {
      title: "Results that speak for themselves",
      subtitle: "Proven in the field, day after day.",
      items: [
        { value: 30, prefix: "+", suffix: "%", label: "average field productivity gain" },
        { value: 95, prefix: "", suffix: "%", label: "of users satisfied" },
        { value: 500, prefix: "+", suffix: "", label: "points of sale supported" },
        { value: 50, prefix: "+", suffix: "", label: "brands trust us" },
      ],
    },
    testimonial: {
      quote:
        "Orbit saves us precious time every day. Everything is in one place, simple and efficient. My teams adopted it straight away!",
      name: "Thomas D.",
      role: "Store manager",
      ctaTitle: "Ready to make a difference in the field?",
      ctaText: "Join the brands running their points of sale with Orbit.",
      ctaButton: "Book a demo",
    },
    faq: {
      title: "Frequently asked questions",
      subtitle: "Everything you need to know before getting started.",
      items: [
        {
          q: "How long does an Orbit rollout take?",
          a: "A typical rollout takes 4 to 8 weeks depending on your network size: scoping, configuration, team training and launch support are all included.",
        },
        {
          q: "Does Orbit integrate with our existing tools?",
          a: "Yes. Orbit connects to your POS, ERP and HR tools through our native connectors and open API.",
        },
        {
          q: "Can field teams really adopt the tool?",
          a: "The app is mobile-first: onboarding takes under an hour, with no heavy training. 95% of our users report being satisfied.",
        },
        {
          q: "How does pricing work?",
          a: "A monthly base fee per brand, a cost per active store and deployment fees. The per-store price decreases as your network grows.",
        },
        {
          q: "Is our data secure?",
          a: "Your data is hosted in Europe, encrypted, with fine-grained access rights by role and by point of sale.",
        },
      ],
    },
    featuresPage: {
      eyebrow: "Features",
      title: "All your field operations, in one platform",
      subtitle: "Explore the modules that structure your teams' day, from HQ to store.",
      tabs: [
        {
          id: "network",
          label: "Network view",
          title: "Your whole network at a glance",
          text: "Map the performance of every point of sale in real time: revenue, compliance, daily rituals and priority alerts.",
          points: ["Real-time status per store", "Centralised alerts and incidents", "Instant cross-site comparisons"],
        },
        {
          id: "rituals",
          label: "Rituals & checklists",
          title: "Simple rituals, tracked to the minute",
          text: "Openings, closings, HACCP checks: every ritual is guided, timestamped and reported back to HQ automatically.",
          points: ["Mobile checklists with photos", "Automatic reminders when late", "Full history per point of sale"],
        },
        {
          id: "audits",
          label: "Field audits",
          title: "Audits that drive progress",
          text: "Customisable audit grids, annotated photos and action plans assigned directly to the relevant teams.",
          points: ["Custom grids per concept", "Compliance score per visit", "Action plans tracked to closure"],
        },
        {
          id: "analytics",
          label: "Comparative analytics",
          title: "Decisions guided by data",
          text: "Compare your stores on the metrics that matter and identify your levers for improvement, store by store.",
          points: ["Consolidated HQ & field KPIs", "Benchmarks across stores", "Automated exports and reports"],
        },
      ],
      ctaTitle: "Want to see Orbit in action?",
      ctaText: "A 30-minute demo, tailored to your sector and your challenges.",
      ctaButton: "Book a demo",
    },
    pricing: {
      eyebrow: "Pricing",
      title: "Clear pricing, built for your network",
      subtitle: "A base fee per brand, a cost per active store. That's it.",
      perMonth: "/month",
      recommended: "Recommended",
      modules: "Included modules",
      deployment: "Deployment fees",
      from: "from",
      perStore: "Price per active store",
      ranges: ["1 to 50 stores", "51 to 100 stores", "101 to 150 stores", "Beyond"],
      onQuote: "On quote",
      cta: "Book a demo",
      note: "Every subscription includes a monthly base fee per brand, a cost per active store and deployment fees.",
      plans: [
        {
          name: "Orbit Starter",
          price: "€290",
          modules: ["Intranet", "Operations centre", "KPIs"],
          deploy: "€2,000",
          storePrices: ["€18", "€14", "€10"],
        },
        {
          name: "Orbit Performance",
          price: "€590",
          modules: ["Everything in Starter", "Support module", "Business module"],
          deploy: "€4,000",
          storePrices: ["€28", "€22", "€17"],
        },
        {
          name: "Orbit Custom",
          price: "€990",
          modules: ["All modules", "Custom developments", "Dedicated integrations"],
          deploy: "€8,000",
          storePrices: ["€38", "€30", "€23"],
        },
      ],
    },
    demo: {
      eyebrow: "Contact",
      title: "Book your personalised demo",
      subtitle: "30 minutes with an Orbit expert to see the platform in action on your use cases.",
      points: ["Reply within 24 business hours", "A demo tailored to your sector", "No commitment"],
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Work email",
        phone: "Phone",
        company: "Brand name",
        stores: "Number of points of sale",
        storesPlaceholder: "Select",
        storeOptions: ["1 to 10", "11 to 50", "51 to 100", "101 to 150", "Over 150"],
        message: "Message",
        messagePlaceholder: "Tell us about your network and your challenges…",
        submit: "Send my request",
        sending: "Sending…",
      },
      success: "Request sent! An Orbit expert will get back to you within 24h.",
      error: "Something went wrong. Please try again in a moment.",
    },
    footer: {
      baseline: "The all-in-one solution for higher-performing points of sale.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      contact: "Contact",
      legalNotice: "Legal notice",
      terms: "Terms of use",
      privacy: "Privacy policy",
      status: "All systems operational",
      copyright: "© 2026 Orbit. All rights reserved.",
    },
    legal: {
      notice: {
        title: "Legal notice",
        body: [
          "Site publisher: Orbit SAS — 12 rue de la Verrerie, 75004 Paris, France.",
          "Publication director: Orbit management.",
          "Hosting: European cloud infrastructure, data hosted in the European Union.",
          "Contact: via the demo request form available on this site.",
        ],
      },
      terms: {
        title: "Terms of use",
        body: [
          "Access to the Orbit platform is reserved for client brands with a valid subscription.",
          "Each user has personal credentials whose confidentiality they must protect.",
          "Data entered into the platform remains the exclusive property of the client brand.",
          "Orbit commits to 99.9% availability and responsive support on business days.",
        ],
      },
      privacy: {
        title: "Privacy policy",
        body: [
          "Data collected via the demo form (identity, professional contact details, brand) is used solely to process your request.",
          "No data is shared with third parties for commercial purposes.",
          "Under GDPR, you have the right to access, rectify and delete your data.",
          "To exercise these rights, contact us via the demo form.",
        ],
      },
    },
    mockup: {
      hello: "Hello Camille!",
      sub: "A well-prepared store means happy customers!",
      weather: "Light rain",
      store: "Leclerc Versailles",
      search: "Search a document, a task…",
      kpis: [
        { label: "Today's revenue", value: "€12,450", trend: "+8% vs yesterday", up: true },
        { label: "Footfall", value: "1,203", trend: "+12% vs Monday", up: true },
        { label: "Average basket", value: "€10.35", trend: "-2% vs last week", up: false },
        { label: "Daily target", value: "86%", trend: "€72,500 / €85,000", up: true },
      ],
      dayTitle: "My day",
      dayLink: "See my full day",
      daySub: "2 actions to complete · 1 overdue",
      tasks: [
        { time: "07:00", label: "Store opening", status: "done" },
        { time: "08:30", label: "Safety check", status: "done" },
        { time: "09:30", label: "Supplier delivery", status: "late" },
        { time: "11:00", label: "Campaign setup", status: "todo" },
      ],
      late: "Overdue",
      newsTitle: "Network news",
      newsLink: "See all",
      newsTag: "Back to school!",
      newsText: "Discover the new in-store campaign.",
      newsCta: "View materials",
      sidebar: ["Home", "My day", "My rituals", "Inventory", "Requests & incidents", "Documents", "My site", "Business modules"],
    },
  },
};
